const breakpoints = {
    phoneSm: "480px",
    phone: "767px",
    tablet: "768px",
    tabletLg: "1024px",
    desktop: "1025px",
    desktopMd: "1400px",
    desktopLg: "1600px",
}

const heightBreakpoints = {
    small: "790px"
}

const getNumericValue = (bpValue) => {
    return parseInt(bpValue.replace(/\D/g, ''));
}

/**
 * Helper function to create media queries based on predefined breakpoints.
 * @param {*} breakpoint - The breakpoint to use, inclusive of the value.
 * @param {string} direction - The direction of the media query. Can be 'up' or 'down'.
 * @param {string} axis - The axis to use. Can be 'x' or 'y'
 * @returns string The media query string
 */
const forSize = (breakpoint, direction, axis = 'x') => {
    let bpValue
    if (axis === 'x') {
        bpValue = breakpoints[breakpoint] || breakpoint;
    } else {
        bpValue = heightBreakpoints[breakpoint] || breakpoint;
    }

    const cssAxis = axis === 'x' ? 'width' : 'height';

    if (!bpValue) {
        throw new Error(`Breakpoint ${breakpoint} not found`);
    }

    if (direction === "up") {
        return `@media (min-${cssAxis}: ${bpValue})`;
    } else if (direction === "down") {
        return `@media (max-${cssAxis}: ${bpValue})`;
    } else {
        throw new Error(`Invalid direction ${direction}. Use 'up' or 'down'.`);
    }
}

export { breakpoints, heightBreakpoints, forSize, getNumericValue };